<template>
  <el-dialog
    :title="$t('affiliateUserManage.affiliateApplyAudit')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('affiliateUserManage.affiliateUser')">
        <el-input v-model="formData.userName" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateUserManage.affiliateLevel')">
        <el-input v-model="formData.level" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateUserManage.applyDesc')">
        <el-input 
          v-model="formData.remark" 
          type="textarea"
          :rows="3"
          disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateUserManage.status')" required>
        <el-select v-model="formData.state" style="width:100%">
          <el-option :label="$t('affiliateUserManage.pleaseAudit')" value="" disabled />
          <el-option :label="$t('affiliateUserManage.pass')" value="1" />
          <el-option :label="$t('affiliateUserManage.reject')" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('affiliateUserManage.reason')" required>
        <el-input
          v-model="formData.auditReason"
          type="textarea"
          :rows="3"
          :placeholder="$t('affiliateUserManage.pleaseInputReason')"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { auditAffiliateUser } from '@/api/affiliate/affiliateUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AuditAffiliateUser',
  data() {
    return {
      dialogVisible: false,
      formData: {
        auId: '',
        level: '',
        userName: '',
        state: '',
        auditReason: '',
        remark: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      Object.assign(this.formData, data)
      this.formData.state = ''
      this.formData.shopId = getShopId()
      this.dialogVisible = true
    },
    resetForm() {
      this.formData = {
        auId: '',
        level: '',
        userName: '',
        state: '',
        auditReason: '',
        remark: '',
        shopId: ''
      }
    },
    handleClose() {
      this.resetForm()
    },
    async handleSubmit() {
      if (!this.formData.state) {
        this.$message.warning(this.$t('affiliateUserManage.pleaseSelectAuditStatus'))
        return
      }
      if (!this.formData.auditReason) {
        this.$message.warning(this.$t('affiliateUserManage.pleaseInputReason'))
        return
      }

      try {
        await auditAffiliateUser(this.formData)
        this.$message.success(this.$t('common.operateSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('审核分销员失败:', error)
      }
    }
  }
}
</script>